import { resetPassActions, resetPassActionTypes } from './resetPass.actions';
import { ResetPassState } from './resetPass.state';

const defaultState: ResetPassState = {
    error: 0,
    ok: false,
    result: {},
};

export type Action = resetPassActions;

export function ResetPassReducer(state = defaultState, action: any) {
    switch (action.type) {
        case resetPassActionTypes.RESET_STATUS:
            return {
                ...state,
                ok: false,
                error: 0,
            };
        case resetPassActionTypes.DO_RESET_SUCCESS:
            return {
                ...state,
                ok: true,
                error: 0,
                result: action.payload,
            };
        case resetPassActionTypes.DO_RESET_FAIL:
            return {
                ...state,
                ok: false,
                error: action.error,
                result: action.payload,
            };
        default:
            return state;
    }
}
